<template>
    <div class="border rounded p-3 mb-3 pb-3 mt-1 position-relative">

        <!-- Params Button -->
        <div class="position-absolute is--top-right mt-3 mr-4 me-4" style="z-index: 1000" v-if="collapse">
            <a href="#" @click.prevent="toggleCollapse" class="text-dark">
                <Icon :icon="isCollapsed ? 'caret-down' : 'caret-left'" />
            </a>
        </div>
        <!-- / Params Button -->

        <!-- Slot -->
        <slot></slot>
        <!-- / Slot -->

        <!-- Collapse -->
        <template v-if="collapse">
            <div class="mt-2">
                <a href="#" @click.prevent="toggleCollapse" class="mr-2 mb-md-0 d-block d-md-inline-block text-decoration-none">
                <span v-if="isCollapsed">
                    <Icon icon="search-minus" /> {{ $t('user-account.lessDetails') }}
                </span>
                <span v-else>
                    <Icon icon="search-plus" /> {{ $t('user-account.moreDetails') }}
                </span>
                </a>
            </div>
            <div :class="{ 'collapsed': isCollapsed }" class="collapsable">
                <slot name="collapsed" v-if="isCollapsed"></slot>
            </div>
        </template>
        <!-- / Collapse -->

    </div>
</template>

<script>
    export default {
        data() {
            return {
                isCollapsed: false
            }
        },
        methods: {
            toggleCollapse() {
                this.isCollapsed = !this.isCollapsed
            }
        },
        computed: {
            collapse: function() {
                return !!this.$slots.collapsed
            }
        }
    }
</script>

<style type="text/css" scoped>
    .is--top-right {
        top: 0;
        right: 0;
    }
</style>
